import { useNavigationContainerRef } from "@-/com.npmjs.expo-router";

/**
 * Route-name fragment for the review flow. Advancing a card navigates within the review subtree
 * between the drill front (`review/[morpheme]/drill/[type]/index`) and the revealed card
 * (`review/[morpheme]/card/index`); the keyboard must persist across those hops so it is only ever
 * dismissed by the explicit collapse button. Matched as a substring because expo-router route names
 * carry the full grouped segment path (verified at runtime).
 */
const PERSIST_KEYBOARD_ROUTE_FRAGMENTS = ["review/"] as const;

/**
 * Returns an `onUnmount` callback for `CollapsiblePersistentKeyboard`.
 * Returns `true` (persist keyboard) when the destination is a card review
 * front/back route; `false` (dismiss) for all other destinations.
 */
export function useCollapsibleKeyboardUnmount(): () => boolean {
  const navigationRef = useNavigationContainerRef();

  return () => {
    const route = navigationRef.current?.getCurrentRoute();
    const routeName = Reflect.get(route ?? {}, "name");
    if (typeof routeName !== "string") {
      return false;
    }
    return PERSIST_KEYBOARD_ROUTE_FRAGMENTS.some((fragment) => routeName.includes(fragment));
  };
}
